module.exports = __webpack_public_path__ + "img/quickship_icon_2.cd011b0b.png";